<template>
  <div v-bind:class="['row', rowClass]">
    <div class="col-2 p-0 align-self-center" style="text-align: right">{{ data[name] }}</div>
    <div class="col-7 fs-90"><small>{{ title }}</small></div>
    <div class="col-2 p-0 d-flex">
      <div v-bind:class="['align-self-stretch', tableName + '-' + name]" :style="data[name + 'Width']" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import BaseIcon from '../../components/icons/BaseIcon.vue'

export default {
  name: 'SupplierRFQRow',
  props: ['rowClass', 'tableName', 'name', 'title', 'data'],
  components: {
    BaseIcon
  },
  async mounted () {
  }, // end mounted
}

</script>


// WEBPACK FOOTER //
// SupplierRFQRow.vue?78b11088